import { render, staticRenderFns } from "./ShippingCompanyForOrderPopup.vue?vue&type=template&id=1c5a77e3&scoped=true"
import script from "./ShippingCompanyForOrderPopup.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyForOrderPopup.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompanyForOrderPopup.vue?vue&type=style&index=0&id=1c5a77e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a77e3",
  null
  
)

export default component.exports